export default __webpack_public_path__ + "media/waiting-room-get-started.d24f1c82.webp";